import { createContext, useCallback, useContext, useEffect } from 'react';

import { useUser } from '#/contexts/UserEnvironmentContext';
import { listingApiCancelEventRsvp } from '#/modules/listing/events/api/listingApiCancelEventRsvp';
import { listingApiFetchOwnRsvp } from '#/modules/listing/events/api/listingApiFetchOwnRsvp';
import type { ApiOwnRsvp } from '#/modules/listing/events/api/types/ApiRsvpResponse';

export type RsvpAnswerContextType = {
  ownRsvp: ApiOwnRsvp | null;
  setOwnRsvp: (ownRsvp: ApiOwnRsvp | null) => void;
};

export const RsvpAnswerContext = createContext<RsvpAnswerContextType>({
  ownRsvp: null,
  setOwnRsvp: () => {},
});

// NOTE exactly one use of this hook must have doInit set
export function useRsvpAnswer(listingId: string, doInit = false) {
  const { ownRsvp, setOwnRsvp } = useContext(RsvpAnswerContext);
  const { user } = useUser();

  useEffect(() => {
    if (doInit && user) {
      void listingApiFetchOwnRsvp(listingId).then((r) => {
        setOwnRsvp(r);

        return undefined;
      });
    }
  }, [doInit, listingId, setOwnRsvp, user]);

  const cancelRsvp = useCallback(async () => {
    if (!ownRsvp) return;
    const response = await listingApiCancelEventRsvp(listingId, ownRsvp.id);
    setOwnRsvp(response.ownRsvp);
  }, [listingId, ownRsvp, setOwnRsvp]);

  return {
    ownRsvp,
    setOwnRsvp,
    cancelRsvp,
  };
}
